module.exports = __webpack_public_path__ + "img/aegeo_logo.7e6cb395.png";